import { SagaReduxAction } from './helper';

export const CreateBunkerPlan = new SagaReduxAction('BUNKER_PLAN_CREATE', (bunkerPorts, baseRequest, requestUuid) =>
  ({
    bunkerPorts: bunkerPorts,
    baseRequest: baseRequest,
    requestUuid: requestUuid
  })
);